import {
    MapOptions
} from "esdm-map/dist";
import { AberdeenshireBaseLayerTypes } from "./AberdeenshireBaseMapping_3857";

export class DefaultMapOptions {

    public static GetDefaultOptions(
        mapElementId: string,
        mapStoreKey: string
    ): MapOptions {       

        let opt = new MapOptions();       
        opt.bingApiKey = $(`#${mapElementId}`).data("bing-api-key");
        opt.esdmOsmApiKey = $(`#${mapElementId}`).data("esdm-osm-api-key");
        opt.baseMaps = [
            AberdeenshireBaseLayerTypes.AberdeenshireOS,
            AberdeenshireBaseLayerTypes.AberdeenshireAerial,
            AberdeenshireBaseLayerTypes.AberdeenshireOSHistoric_1stEdition,
            AberdeenshireBaseLayerTypes.AberdeenshireOSHistoric_2ndEdition
        ];
        opt.defaultBaseMap = AberdeenshireBaseLayerTypes.AberdeenshireOS;
        opt.enableBoundsTracking = true;
        opt.zoomToNearestBounds = false;
        opt.maxZoomToBounds = 18;
        opt.mapElementId = mapElementId;
        opt.mapStoreKey = mapStoreKey;
        opt.mapZoom = 9;
        opt.minZoom = 8;
        opt.maxZoom = 18;

        //HER extent
        opt.extent = [-423100, 7650800, -196500, 7910200];
        opt.mapCentre = [
            //Centre of HER area, alter to Aberdeen?
            -312848, 7799134
        ];    

        opt.displayProjection = "EPSG:3857";
        opt.dataProjection = "EPSG:27700";
        opt.dragRotateAndZoom = false;                
        return opt;
    }

}
